import { render } from "./ToastButton.vue?vue&type=template&id=4b5d06df&scoped=true"
import script from "./ToastButton.vue?vue&type=script&lang=js"
export * from "./ToastButton.vue?vue&type=script&lang=js"

import "./ToastButton.vue?vue&type=style&index=0&id=4b5d06df&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b5d06df"]])

export default __exports__